<template>
    <SidebarChild
        :selected-item="value"
        :items="ChatbotMenuItems"
        @selected="selectedItem"
        :focusActive="true"
        default-open
        className="chatbot-menu"
    />
</template>
<script>
import ChatbotMenuItems from "./ChatbotMenuItems";
import { mapGetters, mapState } from "vuex";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";

export default {
    name: "ChatbotMenu",
    components: {
        SidebarChild,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    data: () => ({
        ChatbotMenuItems: ChatbotMenuItems(this),
    }),
    mounted() {
        this.ChatbotMenuItems = ChatbotMenuItems(this);
    },
    methods: {
        selectedItem({ key }) {
            this.$emit("input", key);
        },
    },
};
</script>

<style lang="scss">
.chatbot-menu {
    .sidebar-menu-item-text {
        max-width: unset !important;
        min-width: unset !important;
    }
}
</style>
